import { AbLoads } from "../../Viewer/LoadExam/AbLoads"


export function rerenderTask(){
    AbLoads()
    MathJax.typeset()
}